/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementCallbackRequestDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementCallbackRequestDto';
import type { Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDashboardDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDashboardDto';
import type { Wealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto';
import type { Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DisbursementService {

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppDisbursementCallBackRequest(
        requestBody?: Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementCallbackRequestDto,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/disbursement/call-back-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param disbursementStatusId
     * @param disbursementContainerStatusId
     * @param companyIds
     * @param date
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementExportDisbursement(
        disbursementStatusId?: Array<number>,
        disbursementContainerStatusId?: Array<number>,
        companyIds?: Array<string>,
        date?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/export-disbursement',
            query: {
                'DisbursementStatusId': disbursementStatusId,
                'DisbursementContainerStatusId': disbursementContainerStatusId,
                'CompanyIds': companyIds,
                'Date': date,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppDisbursementImportDisbursements(
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/disbursement/import-disbursements',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param disbursementStatusId
     * @param disbursementContainerStatusId
     * @param companyIds
     * @param date
     * @returns Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDashboardDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementDashboard(
        disbursementStatusId?: Array<number>,
        disbursementContainerStatusId?: Array<number>,
        companyIds?: Array<string>,
        date?: string,
    ): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDashboardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-dashboard',
            query: {
                'DisbursementStatusId': disbursementStatusId,
                'DisbursementContainerStatusId': disbursementContainerStatusId,
                'CompanyIds': companyIds,
                'Date': date,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param disbursementStatusId
     * @param disbursementContainerStatusId
     * @param companyIds
     * @param date
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto_Wealthlane_AwardSettlementService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementDisbursementDetail(
        disbursementStatusId?: Array<number>,
        disbursementContainerStatusId?: Array<number>,
        companyIds?: Array<string>,
        date?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto_Wealthlane_AwardSettlementService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/disbursement-detail',
            query: {
                'DisbursementStatusId': disbursementStatusId,
                'DisbursementContainerStatusId': disbursementContainerStatusId,
                'CompanyIds': companyIds,
                'Date': date,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardSettlementApiAppDisbursementDisbursement(
        requestBody?: Array<Wealthlane_AwardSettlementService_Dtos_Disbursement_ExportDisbursementDto>,
    ): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award-settlement/api/app/disbursement/disbursement',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
